/** Size of a status mark, such as an approval status, in a menu row. */
export const STATUS_MARK_PX = 14;
/** Height of a menu row's label line: 12 px text at a 1.5 line height. */
export const LABEL_LINE_PX = 18;
